import React from 'react';
import { useMsal, useAccount } from '@azure/msal-react';
import { DocumentUploadsControl } from '../../../../common/components/DocumentUploads';
import { useAppSelector } from '../../../../../app/hooks';
import {
  useListDocumentsQuery,
  useUploadDocumentMutation,
  useDownloadDocumentMutation,
  useDeleteDocumentMutation
} from '../../../../../services/TicketService';

/**
 * DocumentsSection - thin Ticket-specific wrapper around the shared DocumentUploadsControl.
 * Wires Ticket document hooks and renders inside the "Documents" tab.
 */
export const DocumentsSection: React.FC = () => {
  const { currentTicket } = useAppSelector(state => state.ticket);
  const ticketId = currentTicket?.id || '';

  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const currentUserName = account?.name || '';

  const { data: documents, isLoading, isError, error } = useListDocumentsQuery(ticketId, {
    skip: !ticketId
  });
  const [uploadDocument] = useUploadDocumentMutation();
  const [downloadDocument] = useDownloadDocumentMutation();
  const [deleteDocument] = useDeleteDocumentMutation();

  const isFacTicket = currentTicket?.category === 'FAC' || currentTicket?.category === 'Facility Maintenance';

  return (
    <DocumentUploadsControl
      entityId={ticketId}
      documents={documents}
      isLoading={isLoading}
      isError={isError}
      error={error}
      currentUserName={currentUserName}
      defaultDocumentType={isFacTicket ? 'Quote' : 'General'}
      onUpload={(file, documentType) => uploadDocument({ ticketId, file, fileName: file.name, documentType }).unwrap().then(() => undefined)}
      onDownload={(documentId) => downloadDocument({ ticketId, documentId }).unwrap()}
      onDelete={(documentId) => deleteDocument({ ticketId, documentId }).unwrap().then(() => undefined)}
    />
  );
};

export default DocumentsSection;

